<template>
    <div class="main">
        <div class="app-name">
            <rich-logo/>
            <div>
                <h2>Rich'en Danse</h2>
                <p>Espace membre</p>
            </div>
        </div>
        <div class="connexion container">
            <div>
                <h1>Connexion</h1>
                <form @submit.prevent="login" :model="ruleForm" :rules="rules" ref="ruleForm">
                    <uni-input-container label="Adresse e-mail"
                                         id="email"
                    >
                        <uni-input type="email"
                                   id="email"
                                   v-model="ruleForm.email"
                                   required
                                   paceholder="nom@entreprise.fr"
                                   @blur.native="isErrorWithAdress = false"
                        >
                        </uni-input>
                    </uni-input-container>

                    <!-- Mot de passe -->
                    <uni-input-container label="Mot de passe"
                                         id="password"
                    >
                        <uni-input-password
                                id="password"
                                v-model="ruleForm.password"
                                required
                                @blur.native="isErrorWithAdress = false">
                        </uni-input-password>
                    </uni-input-container>

                    <info-message v-if="isAttemptAnError">
                        Vous avez entré un mauvais e-mail, mot de passe ou les deux. Veuillez recommencer.
                    </info-message>
                    <info-message v-if="signatureExpired">
                        Votre session a expiré, veuillez vous reconnecter.
                    </info-message>

                    <info-message v-if="isAccountNotConfirmed">
                        Votre compte n'est pas vérifié. Veuillez vérifier votre compte en cliquant sur le lien qui vous a été envoyé par e-mail lors de la création de votre compte.
                    </info-message>

                    <info-message status="success" v-if="isRecover">
                        Votre mot de passe a bien été modifié.
                    </info-message>

                    <info-message status="success" v-if="adminMessage">
                        Votre compte a été créé. Vous pouvez vous connecter.
                    </info-message>

                    <uni-loading-button :is-disable="buttonIsLoading" text="Connexion"/>
                </form>
                <specific-info v-show="isErrorWithAdress"
                               :is-warning="true"
                               title="Aucune compte n'est associé à cette adresse mail."
                />
            </div>
            <div class="actions">
                <div>
                    <p>Pas encore de compte ?</p>
                    <router-link class="uni-link"
                                 to="/inscription"
                    >
                        Créer mon compte
                    </router-link>
                </div>
                <div>
                    <p>Mot de passe oublié ?</p>
                    <router-link class="uni-link"
                                 :to="{name: 'recover.send', params: {email: ruleForm.email}}"
                    >
                        Réinitialiser mon mot de passe
                    </router-link>
                </div>
            </div>
        </div>
        <div class="pub-uni">
            <a href="https://www.studio-uni.fr" target="_blank">
                Application créée par le Studio Uni
            </a>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex'
    import UniButton from "../../components/a-elements/UniButton";
    import UniLogo from "../../components/a-elements/UniLogo";
    import UniCircularLoader from "../../components/a-elements/UniCircularLoader";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";
    import SpecificInfo from "../../components/b-patterns/SpecificInfo";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import UniInputPassword from "../../components/a-elements/UniInputPassword";
    import InfoMessage from "../../components/a-elements/InfoMessage";
    import RichLogo from "../../components/a-elements/RichLogo";

    export default {
        name: 'Login',
        components: {
            RichLogo,
            InfoMessage,
            UniInputPassword,
            UniInput,
            UniInputContainer,
            SpecificInfo,
            UniLoadingButton,
            UniCircularLoader,
            UniLogo, UniButton
        },
        data() {
            return {
                // userWantsToConnect: true,
                adminMessage: false,
                buttonIsLoading: false,
                isErrorWithAdress: false,
                isAccountNotConfirmed: false,
                signatureExpired: false,

                isAttemptAnError: false,
                isRecover: false,

                ruleForm: {
                    email: '',
                    password: '',
                },
                rules: {
                    email: [
                        {
                            type: "email",
                            required: true,
                            message: "Veuillez entrez un email valide.",
                            trigger: 'blur'
                        }
                    ]
                },
                messageType: '',
            }
        },
        computed: {
            ...mapGetters({currentFamily: 'currentFamily'})
        },
        created() {
            this.checkCurrentLogin()
            if (this.$route.params.init) {
                this.isRecover = true
            }
            if (this.$route.params.admin) {
                this.adminMessage = true
            }
            if (this.$route.params.q) {
                this.signatureExpired = true
            }
        },
        methods: {
            setMessage(message) {
                document.querySelector('.message').innerHTML = message
            },
            checkCurrentLogin() {
                if (this.currentFamily) {
                    this.$router.push('/')
                }
            },
            login() {
                let $this = this;
                this.buttonIsLoading = true;
                this.$http.post('/login', {email: this.ruleForm.email, password: this.ruleForm.password})
                    .then((result) => {
                        this.userWantsToConnect = false
                        this.loginSuccessful(result)
                    })
                    .catch((error) => {
                        this.isAttemptAnError = true
                        this.isRecover = false
                    })
                    .finally(() => {

                        this.buttonIsLoading = false;
                    })
            },
            loginSuccessful(req) {
                let $this = this
                if (!req.data.auth_token) {
                    this.loginFailed(req.data)
                    return
                }
                localStorage.token = req.data.auth_token
                this.$store.dispatch('login')
                document.location.reload()
                this.$router.push('/')
            },
            loginFailed(req) {
                this.isAccountNotConfirmed = true
                this.isAttemptAnError = false
                this.isRecover = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        height: 100vh;
    }


    .connexion {
        max-width: 450px;
        width: 100%;
        margin: 0 auto;
        background: var(--surface-color-light);

        h1 {
            margin-bottom: var(--s-xl);
        }

        &__new {
            margin-top: var(--s-xxl);
            text-align: center;
        }
    }

    .pub {
        display: none;
    }

    .app-name {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        padding: 8px;

        > div {
            p {
                margin-bottom: 0;
            }

            h2 {
                line-height: 16px;
                margin-bottom: 0;
            }
        }
    }

    .pub-uni {
        position: fixed;
        padding: 8px;
    }

    @include screen-xs {
        .pub-uni {
            padding: 16px;
        }
        .app-name {
            padding: 16px;
        }
    }

    @include screen-l {
        .main {
            .pub-uni {
                bottom: 24px;
                padding: 16px 24px;
            }
        }

        .app-name {
            margin-bottom: 84px;
            padding: 16px 24px;
        }

    }
</style>
